<kc-labeled-tabs
  class="full-width"
  [tabs]="tabs"
  [selectedTabId]="selectedTabId()"
  (selectedTabChange)="onTabChange($event)"
>
  @switch (selectedTabId()) {
    @case ("l2-ERC20") {
      <app-erc20-summary />
    }
    @case ("l2-tx-history") {
      <app-l2-tx-history />
    }
  }
</kc-labeled-tabs>

@if (showImportTokenFab()) {
  <div class="import-token-fab">
    <kc-button
      [variant]="'secondary'"
      [size]="'s'"
      [text]="'+ Import Token'"
      (buttonClick)="onImportToken()"
    />
  </div>
}
